import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

const AdminAllBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const navigate = useNavigate();

    // Fetch blogs from the backend
    const get_all_blogs = async () => {
        const token = localStorage.getItem('admin_token');
        if (!token) {
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/blogs/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setBlogs(data);
            } else {
                alert('Failed to fetch blogs');
            }
        } catch (error) {
            console.error('Error fetching blogs:', error);
            alert('An error occurred while fetching blogs');
        }
    };

    // Trigger fetching blogs on component mount
    useEffect(() => {
        get_all_blogs();
    }, []);

    // Handle navigation to blog edit page
    const handleBlogClick = (blogId) => {
        navigate(`/admin/blog/${blogId}`);
    };

    return (
        <div className="p-4">
            <Helmet>
                <title>Tüm Bloglar - Legalbul Admin Paneli</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <h2>Admin Blog Edit</h2>
            <div className="mt-4">
                {blogs.length > 0 ? (
                    <ul className="list-group">
                        {blogs.map((blog) => (
                            <li
                                key={blog.id}
                                className="list-group-item d-flex justify-content-between align-items-center"
                                onClick={() => handleBlogClick(blog.id)}
                                style={{ cursor: 'pointer' }}
                            >
                                {blog.title}
                                <span className="badge bg-primary">Edit</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>Blog bulunamadı.</p>
                )}
            </div>
            <button
                onClick={() => navigate('/admin/index')}
                className="btn btn-danger mt-5"
            >
                Geri Dön
            </button>
        </div>
    );
};

export default AdminAllBlogs;
